/**
 * A clear answer on an A/B test, filed on the test so it is mailed once.
 * Shared by UI tests (schemas/ui-tests.ts) and widget feed tests
 * (schemas/widget-feed-experiments.ts); the rule is utils/experiment-verdict.ts.
 */
import { z } from 'zod';

/**
 * The daily cron's clear answer on a test's main goal (utils/experiment-verdict.ts),
 * recorded once so it is mailed once. `winner` names an arm; `control` means
 * every arm lost to control; `none` means no clear answer by the deadline.
 */
export const ExperimentVerdictRecordSchema = z.object({
  outcome: z.enum(['winner', 'control', 'none']),
  arm: z.string().nullable(),
  goal: z.string(),
  reason: z.string(),
  decidedAt: z.string(),
  /** What the cron did about it: nothing (a person decides), promoted the arm, or stopped the test. */
  acted: z.enum(['none', 'promoted', 'stopped']),
  arms: z.array(z.object({
    arm: z.string(),
    n: z.number(),
    value: z.number().nullable(),
    lift: z.number().nullable(),
    p: z.number().nullable(),
  })),
});
export type ExperimentVerdictRecord = z.infer<typeof ExperimentVerdictRecordSchema>;
